import api from '../REST/api';
import withResolved from '../REST/with-resolved';

export default function withCampaignsAsData(
  WrappedComponent,
  basic = true,
  search = {},
) {
  function deriveQueryArgs({
    brandIds,
    ownerId,
    relevantFor,
    relevantForSalesTeam,
  }) {
    return {
      search: {
        brandIds,
        ownerId,
        relevantFor,
        relevantForSalesTeam,
        ...search,
      },
    };
  }

  const query = basic ? api.getCampaignsBasic : api.getCampaigns;

  return withResolved({
    query,
    deriveQueryArgs,
    as: 'data',
  })(WrappedComponent);
}
